import { Link } from "react-router-dom"; 
import { Helmet } from "react-helmet";

export default function Custom404() {
  return (
    <div className="h-[800px]">
      <Helmet>
        <title>
          404 - Page Not Found | Applied BAS
        </title>
        <meta charset="UTF-8" />
        <meta name="description" content="The page you're looking for doesn't exist or is under construction. Return to Applied BAS home page to explore our building automation services in Dallas-Fort Worth." />
        <meta name="keywords" content="404, Page Not Found, Applied BAS" />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://www.appliedbas.com/404" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.appliedbas.com/404" />
        <meta property="og:title" content="404 - Page Not Found | Applied BAS" />
        <meta property="og:description" content="The page you're looking for doesn't exist. Return to Applied BAS home page." />
        <meta property="og:image" content="https://www.appliedbas.com/ABAS_logo.png" />
        <meta property="og:site_name" content="Applied BAS" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.appliedbas.com/404" />
        <meta name="twitter:title" content="404 - Page Not Found | Applied BAS" />
        <meta name="twitter:description" content="The page you're looking for doesn't exist. Return to Applied BAS home page." />
        <meta name="twitter:image" content="https://www.appliedbas.com/ABAS_logo.png" />
      </Helmet>
      <div className="mt-80 text-center">
        <h1 className="text-3xl font-semibold">Page under construction</h1>
        <p className="">
          This page will be ready soon. In the meanwhile, please head back to
          <Link to="/" className="text-primary hover:underline"> Home</Link>
        </p>
      </div>
    </div>
  );
}
